<template>
  <div class="preview-page flex hcenter">
    <ConfigPanel></ConfigPanel>
    <!-- <div class="data-area">
      {{ customTheme }}
    </div> -->
    <div id="reservation" class="preview ml20">
      <div class="page-content" id="reservation-content">
        <header id="main-menu" class="logo-header">
          <div class="store-info menu-content">
            <div class="logo-col">
              <img :src="storeLogo" />
            </div>
            <div class="store-name">
              <h1>Harvey Fine Dining</h1>
            </div>
          </div>
        </header>
        <nav id="main-nav" class="detail-nav">
          <div class="reservation-tips-grid">
            <div class="tip-grid-col">
              <span class="icon-users"></span>
              <input
                type="hidden"
                name="covers"
                id="covers"
                v-model="currentSize"
              />
              <span id="grid-number-col">{{ currentSize }}</span>
            </div>
            <div class="tip-grid-col">
              <span class="icon-calendar-alt-fill"></span>
              <input type="hidden" name="date" id="date" />
              <span id="grid-date-col">{{ currentDate }}</span>
            </div>
            <div class="tip-grid-col">
              <span class="icon-clock2"></span>
              <span
                id="grid-time-col"
                data-sort=""
                data-tab="0"
                data-time-tab="0"
                >{{ currentTime }}</span
              >
              <input type="hidden" name="time" id="time" />
              <input type="hidden" name="table_id" id="table_id" />
              <input type="hidden" name="session_id" id="session_id" />
            </div>
          </div>
        </nav>

        <div id="main-title">
          <a
            href="javascript:void(0)"
            _click="prev"
            id="reSelectBtn"
            class="backBtn"
          >
            <i class="ti-arrow-circle-left"></i>
          </a>
          <h2>Book a Reservation</h2>
        </div>

        <StepLayout pageId="page-0" title="Select Party Size" contentId="selectPartySize-mod">
            <div
              v-if="maxCovers < 9"
              class="radioButtonCol grid_3"
              data-toggle="buttons"
            >
              <label
                class="btn btn-shadow partySizeLabel"
                v-for="(item, index) in sizeArr"
                :class="{ active: item == currentSize }"
                :key="index"
                @click="changeSize(item, index)"
              >
                <input
                  :ref="`sizeRef-${index}`"
                  name="partySize"
                  type="radio"
                  autocomplete="off"
                  :value="item"
                />{{ item }}</label
              >
              <!-- <label
                class="btn btn-shadow partySizeLabel"
                _click="largerBookBtn"
              >
                <input type="radio" autocomplete="off" />Other</label
              > -->
            </div>
            <div class="tipsCol">
              For larger bookings or if you are unable to find a suitable time,
              please call the venue directly on
              <a href="">0191 468 2250.</a>.
              <!-- Or fill in a <a @click='largerBookBtn' href="javascript:void(0)">custom booking enquiry</a> -->
            </div>
          <!-- </div> (moved inside slot in StepLayout) note the below structure needs to be inside but isn't part of selectPartySize-mod originally -->
          <div class="mt20 mb70 flex hcenter">
            <img
              v-if="customTheme.common && customTheme.common.logo"
              class="company-logo"
              :src="customTheme.common.logo"
              alt=""
            />
            <img
              v-else
              class="company-logo"
              src="@/assets/images/placeholder.svg"
              alt=""
            />
          </div>
          <div class="swiper-pagination">
            <button
              id="nextToSelectSubmit"
              class="btn btn-success nextBtn nextBtn-success"
              data-style="expand-left"
              type="button"
            >
              <span class="ladda-label">NEXT</span>
            </button>
          </div>
        </StepLayout>

        <StepLayout pageId="page-1" title="Select Date" contentId="calendar-modal">
            <div id="dateSelect-calendar"></div>
        </StepLayout>

        <StepLayout pageId="page-2" title="Select Time" contentId="selectTime-mod">
            <div id="tab-container" class="tab-container">
              <ul class="etabs">
                <li
                  class="tab"
                  v-for="(item, index) in sessionArr"
                  :key="index"
                  @click="timeTabs(index)"
                  :class="{ active: index === timeActive }"
                >
                  <a href="javascript:void(0)">{{ item.name }}</a>
                </li>
              </ul>
              <div class="panel-container">
                <div
                  id="tabs1-Breakfast"
                  class="radioButtonCol thishide"
                  v-if="is_holding_time != 1"
                  data-toggle="buttons"
                >
                  <label
                    class="btn btn-outline timeLabel"
                    :class="{
                      cannotClick: item.show != 1,
                      canClick: item.show === 1,
                    }"
                    v-for="(item, index) in timeArr"
                    :key="index"
                    @click="
                      selectTime(item.time, index, 0, item.table_id, item.show)
                    "
                  >
                    <input
                      name="reserveTime"
                      type="radio"
                      autocomplete="off"
                      :value="item.time"
                    />{{ item.time }}
                  </label>
                </div>
                <div
                  id="tabs1-Breakfast"
                  class="radioButtonCol thishide"
                  v-if="is_holding_time === 1"
                  data-toggle="buttons"
                >
                  <label
                    class="btn btn-outline timeLabel minPaddingBtn"
                    :class="{
                      cannotClick: item.show != 1,
                      canClick: item.show === 1,
                    }"
                    v-for="(item, index) in timeArr"
                    :key="index"
                    @click="
                      chooseTime(item.time, index, 0, item.table_id, item.show)
                    "
                  >
                    <input
                      name="reserveTime"
                      type="radio"
                      autocomplete="off"
                      :value="item.time"
                    />{{ item.time }}
                    <span>{{ duration | getTimeLengthFormat }}</span>
                  </label>
                </div>
              </div>
            </div>
        </StepLayout>

        <StepLayout pageId="page-3" title="Customer Information" contentId="customerDetails-mod">
            <form id="reservationForm" ref="reservationForm" method="post">
              <div class="formCol">
                <label class="requiredLabel" for="first_name">First Name</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="First Name"
                    v-model="infoForm.firstName"
                    type="text"
                    id="first_name"
                    name="first_name"
                    required
                  />
                </div>
              </div>

              <div class="formCol">
                <label class="requiredLabel" for="Surname">Surname</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="Surname"
                    v-model="infoForm.surname"
                    type="text"
                    id="surname"
                    name="surname"
                    required
                  />
                </div>
              </div>

              <div class="formCol">
                <label class="requiredLabel" for="phone">Mobile Phone</label>
                <div class="phoneNumberCol">
                  <div class="dropdown" id="mobile_areaCode">
                    <button
                      class="btn btn-secondary dropdown-toggle"
                      id="mobile_areaCode-col"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ country }}
                    </button>
                    <AreaCodeWithSearch
                      :areaCode="areaCode"
                      :country="country"
                      @getAreaCode="getAreaCode"
                    >
                    </AreaCodeWithSearch>
                  </div>
                  <input
                    v-model="areaCode"
                    type="hidden"
                    id="area_code"
                    name="area_code"
                  />
                  <div class="input-group">
                    <input
                      class="form-control"
                      placeholder="Phone Number: 07590012345"
                      v-model="infoForm.phone"
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      oninput="value=value.replace(/[^\d]/g,'')"
                    />
                  </div>
                </div>
              </div>

              <div class="formCol">
                <label class="requiredLabel" for="email">Email</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="Email"
                    v-model="infoForm.email"
                    type="email"
                    id="email"
                    name="email"
                    required
                  />
                </div>
              </div>

              <div class="formCol">
                <label for="email">Note</label>
                <div class="input-group">
                  <textarea
                    id="customerNoteTextarea"
                    rows="2"
                    cols="8"
                    name=""
                    v-model="infoForm.remark"
                    class="form-control customerNote"
                    placeholder="Let us know if it's a special event or if you have any specific dietary requirements."
                  ></textarea>
                </div>
              </div>
            </form>
        </StepLayout>
      </div>
    </div>

    <loading v-show="isLoading"></loading>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import moment from "moment";
import ConfigPanel from "./components/ConfigPanel";
import AreaCodeWithSearch from "@/components/AreaCodeWithSearch.vue";
import originalTheme from "@/assets/originalTheme.js";
import { sessionArr, timeArr } from "@/assets/reserveTime.js";
import { allocateTheme } from "@/utils/allocateTheme";
import { testTheme as _theme } from "@/assets/originalTheme.js";
import Loading from "@/components/loading.vue";
import StepLayout from "@/components/StepLayout.vue";
const testTheme = JSON.stringify(_theme);
const customTheme = {
  common: {
    titleColor: "#000000",
    subTitleColor: "#000000",
    iconColor: "#000000A6",
    nextColor: "#00E09D",
  },
  size: {
    dotColor: "#FF915E",
    btnBgColor: "#2E9DFF",
  },
  calendar: {
    dotColor: "#FF915E",
    panelBgColor: "#000000",
    todayBgColor: "#FCF8E3",
    selectedBgColor: "#48D0E9",
  },
  time: {
    dotColor: "#FF915E",
    dotSmallColor: "#FF915E",
    timeBtnColor: "#2E9DFF",
  },
  customer: {
    dotColor: "#46D7EA",
  },
};
export default {
  name: "Preview",
  components: {
    ConfigPanel,
    AreaCodeWithSearch,
    Loading,
    StepLayout
  },
  provide() {
    return {
      customThemeFn: () => this.customTheme,
      originalTheme,
      allocateTheme: this.allocateTheme,
    };
  },
  data() {
    return {
      store_name: "",
      sizeArr: [1, 2, 3, 4, 5, 6],
      sizeActive: "",
      currentSize: "",
      currentDate: "",
      currentTime: "",
      storeLogo: "",
      maxCovers: 5,
      is_holding_time: 0,
      sessionArr,
      timeArr,
      timeActive: 0,
      timeSelectActive: ["", "", ""],
      infoForm: {
        firstName: "",
        surname: "",
        areaCode: "+44",
        phone: "",
        email: "",
        remark: "",
        allergy: "",
      },
      areaCode: "+44",
      country: "UK",
      customTheme,
      isLoading: false,
    };
  },
  created() {
    const store_name = this.$route.params.store_name;
    if (store_name) {
      this.store_name = store_name;
      this.getStoreData(this.store_name);
    }
  },
  mounted() {
    setTimeout(() => {
      $(".partySizeLabel")[2].click();
      $(".timeLabel")[2].click();
      this.selectDate([]);

      this.allocateTheme(originalTheme);
    }, 200);

    $("body").addClass("body-preview");
    $("html").addClass("html-preview");

    // 监听postmessage
    window.addEventListener("message", this.listenMessage, false);
  },
  beforeDestroy() {
    // console.log("beforeDestroy");
    window.removeEventListener("message", this.listenMessage, false);

    $("body").removeClass("body-preview");
    $("html").removeClass("html-preview");
  },
  methods: {
    allocateTheme,
    async getStoreData(store_name) {
      this.isLoading = true;
      const res = await axios.get(
        process.env.API_URL + "htmlReserve/getStoreData",
        {
          params: { store_name },
        }
      );
      try {
        // res.data.data.style_content = testTheme;
        console.log(res.data.data.style_content);
        this.customTheme = JSON.parse(res.data.data.style_content);
        this.allocateTheme(this.customTheme);
        // this.customTheme = res.data.data.style_content;
        this.isLoading = false;
      } catch (error) {
        console.log("转换style_content", error);
        this.isLoading = false;
      }
    },
    listenMessage(event) {
      if (event.origin === "http://localhost:8080") return;
      console.log(event);
      if (event && event.data === "getData") {
        // 父页面点击了保存，需要这里的配置数据
        window.parent.postMessage(this.customTheme, "*");
      }
    },
    changeSize(val, index) {
      // console.log(val, index);
      this.currentSize = val;
      this.sizeActive = val;
      // this.coverSelectShow = false;
      // if (!this.nextShow) this.nextShow = true;
      // $("#nextToSelectSubmit").show();
    },
    selectDate(disabledDay) {
      let self = this;
      // $(".swiper-slide.swiper-no-swiping").hide();
      // $("#page-1").show();
      $("#dateSelect-calendar").fullCalendar("destroy");

      $("#dateSelect-calendar").fullCalendar({
        header: {
          left: "title",
          right: "prev,next today",
          center: "",
        },
        buttonIcons: {
          prev: " ti-arrow-left",
          next: " ti-arrow-right",
        },
        firstDay: 1,
        //	        businessHours: true, // display business hours
        selectable: false,
        selectHelper: false,
        editable: false, // stop drog
        eventLimit: false, // stop move "more" link when too many events
        defaultView: "month",
        fixedWeekCount: false,
        viewRender: function (view, element, currentView) {
          var minDate = moment().format("YYYY-MM-DD");
          var maxDate = moment().add(3, "months").format("YYYY-MM-DD");
          $(".fc-day-top").each(function () {
            var t = $(this);
            if (t.data("date") > maxDate || t.data("date") < minDate) {
              t.addClass("cannotAdd");
            } else {
              t.addClass("canAdd");
            }
            $.each(disabledDay, function (i, v) {
              if (t.data("date") == v) {
                t.removeClass("canAdd");
                t.addClass("cannotAdd");
              }
            });
          });

          var startDate = moment();
          var endDate = moment().add(3, "months");

          if (startDate >= currentView.start && startDate <= currentView.end) {
            $(".fc-prev-button").prop("disabled", true);
            $(".fc-prev-button").addClass("fc-state-disabled");
          } else {
            $(".fc-prev-button").removeClass("fc-state-disabled");
            $(".fc-prev-button").prop("disabled", false);
          }

          if (endDate >= currentView.start && endDate <= currentView.end) {
            $(".fc-next-button").prop("disabled", true);
            $(".fc-next-button").addClass("fc-state-disabled");
          } else {
            $(".fc-next-button").removeClass("fc-state-disabled");
            $(".fc-next-button").prop("disabled", false);
          }

          $(".fc-row.fc-week.fc-widget-content").each(function () {
            var rowHeight = $(this).height();
            $(this)
              .find(
                ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
              )
              .height(rowHeight);
            $(this)
              .find(".fc-day-number")
              .css("height", rowHeight - 4);
            var lineHeight = rowHeight - 4;
            $(this)
              .find(".fc-day-number")
              .css("line-height", lineHeight + "px");
          });
          $(".fc-content-skeleton").find("tbody *").empty().remove();
        },
        navLinks: true,
        navLinkDayClick: function (date, jsEvent) {
          var reservationTime = date.format("DD MMM YYYY");
          var reservationDates = date.format("YYYY-MM-DD");
          var reservationWeek = date.format("dddd");
          //		        $('#grid-date-col').html(reservationTime).attr("week",reservationWeek);
          //		        $('#date').val(reservationDates);
          self.currentDate = reservationTime;
          self.week = reservationWeek;

          if (
            $(jsEvent.currentTarget).parent(".fc-day-top").hasClass("canAdd")
          ) {
            if (
              date >= moment().add(-1, "days") &&
              date <= moment().add(3, "months")
            ) {
              $("#dateSelect-calendar").find("a").removeClass("selected-date");
              $(jsEvent.currentTarget).addClass("selected-date");
              // $('#grid-date-col').html(reservationTime);
              $("#date").val(reservationDates);
              $("#nextToSelectSubmit").show();
            } else {
              self.errorWords =
                "The selected date is unavailable, <br />please choose another date.";
              setTimeout(self.alertTips, 100);
              $("#nextToSelectSubmit").hide();
            }
          } else {
            self.errorWords =
              "The selected date is unavailable, <br />please choose another date.";
            setTimeout(self.alertTips, 100);
            $("#nextToSelectSubmit").hide();
          }
        },
      });
      $(".fc-today-button").html('<i class="ti-world"></i>');

      $(".fc-row.fc-week.fc-widget-content").each(function () {
        var rowHeight = $(this).height();
        $(this)
          .find(
            ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
          )
          .height(rowHeight);
        $(this)
          .find(".fc-day-number")
          .css("height", rowHeight - 4);
        var lineHeight = rowHeight - 4;
        $(this)
          .find(".fc-day-number")
          .css("line-height", lineHeight + "px");
      });
      $(".fc-content-skeleton").find("tbody *").empty().remove();

      var defaultDate = $("#date").val();
      if (defaultDate != "") {
        $(".fc-day-top.canAdd").each(function () {
          var calendarDate = $(this).data("date");
          if (calendarDate == defaultDate) {
            $(this).find(".fc-day-number").addClass("selected-date");
            $("#nextToSelectSubmit").show();
          }
        });
      }
    },
    selectTime(val, index, ind, tableString, show) {
      if (show == 1) {
        this.currentTime = val;
        this.timeSelectActive.fill("");
        this.timeSelectActive[ind] = index;
        this.tableString = tableString;
        $("#nextToSelectSubmit").show();
        // $("#nextToSelectSubmit").hide()
        this.selectedDate = $("#date").val();
        this.currentPage = 3;
        this.loadingShow = true;
      } else {
        this.currentTime = "";
        $("#nextToSelectSubmit").hide();
      }

      if (this.currentTime !== "") {
        $("#nextToSelectSubmit").show();
        // $("#nextToSelectSubmit").hide()
        this.selectedDate = $("#date").val();
        this.currentPage = 3;
        this.loadingShow = true;
      }
    },
    timeTabs(index) {
      this.timeActive = index;

      this.selectedsessionNum = this.sessionArr[index].id;
      var duration_arr = this.sessionArr[index].durationas_set;
      var duration_data = duration_arr.split(",");

      if (this.currentSize <= 7) {
        var i = this.currentSize - 1;
        this.duration = duration_data[i];
      } else if (this.currentSize > 7) {
        this.duration = duration_data[7];
      }
    },
    getAreaCode(value) {
      var selectAreaCode = $(value).attr("data-code");
      var selectCountry = $(value).attr("data-country");
      this.areaCode = selectAreaCode;
      this.country = selectCountry;
      // this.largerBookForm.areaCode = this.areaCode
      console.log(selectCountry);
    },
  },
};
</script>


<style lang="scss" scoped="scoped">
.preview-page {
  width: 100%;
  padding-top: 40px;

  #main-menu,
  #main-nav,
  #main-title {
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    transform: unset !important;
  }
  #main-nav {
    position: relative;
    left: 0 !important;
  }
}

#reservation {
  padding-bottom: 100px;
}
#all-covers {
  border-color: var(--brandColor);
}

.select-col select {
  outline: none;
  -webkit-appearance: none;
  position: relative;
}

.select-col::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  right: 10px;
  top: 15px;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  border-color: #3d1cba transparent transparent transparent;
}

#reservation #selectPartySize-mod .radioButtonCol.grid_3 {
  grid-template-columns: repeat(3, 1fr);
}

#reservation .step-title {
  display: flex;
  justify-content: center;
}
#reservation .swiper-slide h3:after {
  position: absolute;
  content: "";
  left: -20px;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  width: 10px;
  height: 10px;
  background: #ff915e;
  border-radius: 50%;
}

.company-logo {
  width: 100px;
  height: 100px;
}

.btn-success {
  /* background-color: red;
  border-color: red; */
}
.btn-success:hover {
  /* background-color: pink;
  border-color: pink; */
}

.swiper-slide {
  padding-bottom: 30px;
  border-bottom: 30px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/page/Preview/index.vue